import { okeys } from "../brains/flang";
import { paramSources } from "./paramSources";
import { typeSystemMap, TypeSystemMap } from "./typeSystem";

export function isLambda(cloudId: string): boolean {
  return cloudId.startsWith("arn:aws:lambda:");
}

// isLambda("arn:aws:lambda:us-west-2:590194043634:function:addUsers-falcon"); //=
// isLambda("arn:aws:step-function:us-west-2:590194043634:function:something"); //=

export function isStepFunction(cloudId: string): boolean {
  return cloudId.startsWith("arn:aws:states:");
}

// isStepFunction(
//   "arn:aws:states:us-east-1:443117978555:stateMachine:DataPLSM-zuDZMM92I6s3"
// ); //=
// isStepFunction(
//   "arn:aws:lambda:us-east-2:881222034154:function:addNewEntryConflictTimelineIndex"
// ); //=

export function isAzureFunction(cloudId: string): boolean {
  return (
    cloudId.match(
      "^azure::/subscriptions/[^/]+/resourceGroups/[^/]+/providers/Microsoft.Web/sites/[^/]+/functions/[^/]+$"
    ) !== null
  );
}

// const isf = isAzureFunction(
//   "azure::/subscriptions/30e7b10b-eab7-4bb2-8788-e3f7a2fc175e/resourceGroups/110testfunctionnameparam/providers/Microsoft.Web/sites/1-10-TestFunctionNameParam/functions/function-12-7"
// );
// isf; //=

// const notf = isAzureFunction(
//   "NOTazure::/subscriptions/30e7b10b-eab7-4bb2-8788-e3f7a2fc175e/resourceGroups/110testfunctionnameparam/providers/Microsoft.Web/sites/1-10-TestFunctionNameParam/functions/function-12-7"
// );
// notf; //=

export function isMSSQL(cloudId: string): boolean {
  return cloudId.startsWith("db::mssql");
}

// isMSSQL("db::mssql::fomf-sandbox-ssdb.database.windows.net::fomf-ss-sandbox-db::dbo::function::addition_scalar") //=
// isMSSQL("db::postgres::fomf-sandbox-ssdb.database.windows.net::fomf-ss-sandbox-db::dbo::function::addition_scalar") //=

export function isGithub(cloudId: string): boolean {
  return cloudId.startsWith("github::");
}

// isGithub("github::angusm/flank-api") //=

export function isDatabase(cloudId: string): boolean {
  return cloudId.startsWith("db::");
}

// isDatabase("db::mssql::fomf-sandbox-ssdb.database.windows.net::fomf-ss-sandbox-db::dbo::function::addition_scalar") //=

export function isApi(cloudId: string): boolean {
  return cloudId.startsWith("api::");
}

// isApi("api::https://api.example.com") //=

export function canEditDataType(paramSource: string | null): boolean {
  if (!paramSource) {
    return false;
  }
  return paramSources[paramSource as keyof typeof paramSources]
    .canEditDataTypes;
}

// canEditDataType("postman"); //=

export function canAddDeleteParams(paramSource: string | null): boolean {
  if (!paramSource) {
    return false;
  }
  return paramSources[paramSource as keyof typeof paramSources]
    .canAddDeleteParams;
}

// canAddDeleteParams("postman"); //=

export function canSyncInputs(paramSource: string | null): boolean {
  if (!paramSource) {
    return false;
  }
  return paramSources[paramSource as keyof typeof paramSources].canSyncInputs;
}

// canSyncInputs("postman"); //=

export function canEditKeyName(paramSource: string | null): boolean {
  if (!paramSource) {
    return false;
  }
  return paramSources[paramSource as keyof typeof paramSources].canEditKeyName;
}

export function getTypesForTypeSystem(typeSystem: string): string[] {
  return okeys(typeSystemMap[typeSystem as keyof typeof typeSystemMap]);
}

// getTypesForTypeSystem("mssql"); //=
// getTypesForTypeSystem("python"); //=

type TypeInfo = TypeSystemMap["mssql"]["image"];

export function getTypeObject(
  typeSystem: string,
  typeId: string
): TypeInfo | null {
  if (!(typeSystem in typeSystemMap)) {
    return null;
  }
  const types = typeSystemMap[typeSystem as keyof typeof typeSystemMap];
  if (!(typeId in types)) {
    return null;
  }
  return types[typeId as keyof typeof types];
}

// getTypeIdForTypeSystem("mssql", "string"); //=

export function isRScript(cloudId: string | null): boolean {
  if (!cloudId) return false;
  // treat GitHub-hosted files ending in ".R" as R scripts
  if (cloudId.startsWith("github:") && cloudId.endsWith(".R")) return true;
  // add more back-end identifiers here if needed
  return false;
}
